import React, { useRef, useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import { component } from '../../picoapp';
import { ResponsiveImage } from '../parts/ResponsiveImage'

const TikTokPlayer = ({ ctx, parentNode }) => {

  const [coverImg, setCoverImg] = useState(null);
  const id = 'tiktok-video-' + parentNode.dataset.index;

  const parentController = document.querySelector(`#${id}`);
  const videoEl = parentController.querySelector('video');

  useEffect(() => {
    setCoverImg(parentNode.dataset.coverImage)
    parentController.addEventListener('isActive', () => {
      videoEl.play();
    });
    parentController.addEventListener('isInactive', () => {
      videoEl.pause();
    });
  }, [])

  return (
    <figure className="Cover" data-action={`{ type: 'toggle', target: '${id}' }`}>
      {ResponsiveImage({ image: coverImg, classname: 'Cover__img' })}
      <figcaption>
        <svg viewBox="0 0 20 20" className="icon" width="1em" height="1em">
          <use xlinkHref="#play"></use>
        </svg>
      </figcaption>
    </figure>
  );
};

export default component((node, ctx) => {
  const element = <TikTokPlayer ctx={ctx} parentNode={node} />;
  ReactDOM.render(element, node);
});
